<div>
    @if (MinsAgo > 30) {
      <nz-alert nzType="warning" nzMessage="Technician location has not been updated for over 30 minutes."
        nzShowIcon></nz-alert>
    } @else {
        <h3>Last Technician Location Update: {{ latestLocation().dtLogged + 'Z' | date:'short' }} ({{ MinsAgo }} mins ago)</h3>
        <div style="height: 70vh;">
            <google-map
            height="100%"
            width="100%"
            [center]="center()"
            [zoom]="zoom()">

                @if (incident()) {
                    <map-marker
                        [position]="incidentPosition()"
                        [options]="{
                    icon: getIconMarker(),
                    zIndex: 2
                    }">
                    </map-marker>
                }

                <map-marker
                    [position]="spTechPosition()"
                    [options]="{
                    icon: getDriverIconMarker(),
                    zIndex: 3
                    }">
                </map-marker>
                <map-marker
                [position]="spTechPosition()"
                [options]="{
                  icon: getPulseIcon(),
                  zIndex: 1
                }">
            </map-marker>
            </google-map>
        </div>
}


</div>